<template>
    <div>
        <page-headline>{{$t('pages.customerLocks.title')}}</page-headline>
        <div class="bg-white shadow overflow-x-auto mt-6">
            <table class="w-full whitespace-nowrap bg-ezdBlue">
                <tr class="table-headline text-left">
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.head_id')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.head_customer_id')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.head_customer_username')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.head_locked_at')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.bids_count')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.locked_by')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.customerLocks.table.unlock')}}</th>
                </tr>
                <tr v-for="lock in locks.data" :key="lock.id" class="hover:bg-gray-300 even:bg-gray-200 odd:bg-white text-sm" :class="{}">
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ lock.id }}</a></td>
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ lock.customer_id }}</a></td>
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ lock.customer_name }}</a></td>
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ lock.created_at | formatDate }}</a></td>
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ lock.bids_count }}</a></td>
                    <td class="border-t"><a class="px-4 py-3 flex items-center">{{ (lock.user?.name ?? '') + ' ' + (lock.user?.lastname ?? '') }}</a></td>
                    <td class="border-t">
                        <span class="px-4 py-3 flex items-center cursor-pointer" @click="unlockCustomer(lock)">
                            <icon
                                class="h-5 w-5 text-green-700"
                                name="unlock">
                            </icon>
                        </span>
                    </td>
                </tr>
                <tr v-if="locks.data?.length === 0">
                    <td class="border-t px-6 py-4 text-center bg-white" colspan="7">{{$t('pages.customerLocks.no_data')}}</td>
                </tr>
            </table>
        </div>
        <div class="mb-6">
            <pagination :collection="locks" :url="$page.props.paginate.currentUrl" :params="this.form" />
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import Icon from '@/Shared/Icon';
import PageHeadline from "@/Shared/PageHeadline";
import SearchFilter from "@/Shared/SearchFilter";
import { Link } from '@inertiajs/vue2';

export default {
    metaInfo() {
        return {
            title: this.$t('pages.campaigns.index.campaigns')
        }
    },
    layout: Layout,
    components: {
        Pagination,
        Icon,
        PageHeadline,
        SearchFilter,
        Link
    },
    props: {
        locks: Object,
    },
    data() {
        return {
            form: {}
        }
    },
    watch: {},
    methods: {
        unlockCustomer(lock) {
            console.log(lock);
            if (confirm('Möchten Sie den Kunden ' + lock.customer_name + ' wirklich entsperren?')) {
                axios.post(route('customer.unlock', { customerLock: lock.id }))
                    .then((resp) => {
                        this.$inertia.reload();
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }
        }
    }
}
</script>
